import { TeamRecord } from '@/components/league-table/types';

export const calculateTeamStats = (matches: any[]): TeamRecord[] => {
  const teamStats = new Map<string, TeamRecord>();

  matches.forEach(match => {
    // Process home team
    if (!teamStats.has(match.HomeTeam)) {
      teamStats.set(match.HomeTeam, {
        team: match.HomeTeam,
        played: 0,
        wins: 0,
        draws: 0,
        losses: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalDifference: 0,
        points: 0,
        ppg: 0,
        cleanSheets: 0,
        cleanSheetsPercentage: 0,
        btts: 0,
        bttsPercentage: 0,
        yellowCards: 0,
        redCards: 0,
        over15: 0,
        over15Percentage: 0,
        over25: 0,
        over25Percentage: 0
      });
    }

    // Process away team
    if (!teamStats.has(match.AwayTeam)) {
      teamStats.set(match.AwayTeam, {
        team: match.AwayTeam,
        played: 0,
        wins: 0,
        draws: 0,
        losses: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalDifference: 0,
        points: 0,
        ppg: 0,
        cleanSheets: 0,
        cleanSheetsPercentage: 0,
        btts: 0,
        bttsPercentage: 0,
        yellowCards: 0,
        redCards: 0,
        over15: 0,
        over15Percentage: 0,
        over25: 0,
        over25Percentage: 0
      });
    }

    const homeTeamStats = teamStats.get(match.HomeTeam)!;
    const awayTeamStats = teamStats.get(match.AwayTeam)!;

    // Update matches played
    homeTeamStats.played++;
    awayTeamStats.played++;

    // Update goals
    const homeGoals = parseInt(match.FTHG) || 0;
    const awayGoals = parseInt(match.FTAG) || 0;

    homeTeamStats.goalsFor += homeGoals;
    homeTeamStats.goalsAgainst += awayGoals;
    awayTeamStats.goalsFor += awayGoals;
    awayTeamStats.goalsAgainst += homeGoals;

    // Update clean sheets
    if (homeGoals === 0) {
      awayTeamStats.cleanSheets++;
    }
    if (awayGoals === 0) {
      homeTeamStats.cleanSheets++;
    }

    // Update BTTS
    if (homeGoals > 0 && awayGoals > 0) {
      homeTeamStats.btts++;
      awayTeamStats.btts++;
    }

    // Update wins, draws, losses and points
    if (homeGoals > awayGoals) {
      homeTeamStats.wins++;
      homeTeamStats.points += 3;
      awayTeamStats.losses++;
    } else if (homeGoals < awayGoals) {
      awayTeamStats.wins++;
      awayTeamStats.points += 3;
      homeTeamStats.losses++;
    } else {
      homeTeamStats.draws++;
      awayTeamStats.draws++;
      homeTeamStats.points += 1;
      awayTeamStats.points += 1;
    }

    // Update goal differences
    homeTeamStats.goalDifference = homeTeamStats.goalsFor - homeTeamStats.goalsAgainst;
    awayTeamStats.goalDifference = awayTeamStats.goalsFor - awayTeamStats.goalsAgainst;

    // Calculate PPG and percentages
    homeTeamStats.ppg = homeTeamStats.points / homeTeamStats.played;
    awayTeamStats.ppg = awayTeamStats.points / awayTeamStats.played;

    homeTeamStats.cleanSheetsPercentage = (homeTeamStats.cleanSheets / homeTeamStats.played) * 100;
    awayTeamStats.cleanSheetsPercentage = (awayTeamStats.cleanSheets / awayTeamStats.played) * 100;

    homeTeamStats.bttsPercentage = (homeTeamStats.btts / homeTeamStats.played) * 100;
    awayTeamStats.bttsPercentage = (awayTeamStats.btts / awayTeamStats.played) * 100;

    // Update cards
    homeTeamStats.yellowCards += parseInt(match.HY) || 0;
    homeTeamStats.redCards += parseInt(match.HR) || 0;
    awayTeamStats.yellowCards += parseInt(match.AY) || 0;
    awayTeamStats.redCards += parseInt(match.AR) || 0;

    // Calculate total goals in the match
    const totalGoals = homeGoals + awayGoals;

    // Update over 1.5 and 2.5 stats
    if (totalGoals > 1.5) {
      homeTeamStats.over15++;
      awayTeamStats.over15++;
    }
    if (totalGoals > 2.5) {
      homeTeamStats.over25++;
      awayTeamStats.over25++;
    }

    // Calculate percentages
    homeTeamStats.over15Percentage = (homeTeamStats.over15 / homeTeamStats.played) * 100;
    homeTeamStats.over25Percentage = (homeTeamStats.over25 / homeTeamStats.played) * 100;
    awayTeamStats.over15Percentage = (awayTeamStats.over15 / awayTeamStats.played) * 100;
    awayTeamStats.over25Percentage = (awayTeamStats.over25 / awayTeamStats.played) * 100;

    teamStats.set(match.HomeTeam, homeTeamStats);
    teamStats.set(match.AwayTeam, awayTeamStats);
  });

  return Array.from(teamStats.values());
};
